import { z } from 'zod';
import { servicesProviderPricingFlatFeeSchema, servicesProviderPricingLinearHourlySchema, servicesProviderPricingFlatFeeDtoSchema, servicesProviderPricingLinearHourlyDtoSchema } from '../ServicesProviderPricing.js';
import { serviceConfigSchema } from './SharedServiceConfig.js';

// ============================================================================
// Pricing Schemas
// ============================================================================
const assemblyServicePricingSchema = z.discriminatedUnion('model', [
    servicesProviderPricingFlatFeeSchema,
    servicesProviderPricingLinearHourlySchema,
]);
const assemblyServicePricingDtoSchema = z.discriminatedUnion('model', [
    servicesProviderPricingFlatFeeDtoSchema,
    servicesProviderPricingLinearHourlyDtoSchema,
]);
// ============================================================================
// Core Schema
// ============================================================================
const assemblyServiceConfigSchema = serviceConfigSchema.extend({
    pricing: z.array(assemblyServicePricingSchema),
});
// ============================================================================
// DTO Schema
// ============================================================================
const assemblyServiceConfigDtoSchema = serviceConfigSchema.extend({
    pricing: z.array(assemblyServicePricingDtoSchema),
});

export { assemblyServiceConfigDtoSchema, assemblyServiceConfigSchema, assemblyServicePricingDtoSchema, assemblyServicePricingSchema };
//# sourceMappingURL=AssemblyServiceConfig.js.map
